import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { ListHeaderComponent } from './list-header.component';
import { ListToolbarComponent } from './list-toolbar.component';
import { StatusTabsComponent } from './status-tabs.component';
import { RowActionsComponent } from './row-actions.component';
import { ListEmptyComponent } from './list-empty.component';
import { InitialsPipe } from './initials.pipe';
import { RecordBoardCardComponent } from './record-board-card.component';
import { ToolbarFilterSelectComponent } from './toolbar-filter-select.component';

const COMPONENTS = [
  ListHeaderComponent,
  ListToolbarComponent,
  StatusTabsComponent,
  RowActionsComponent,
  ListEmptyComponent,
  RecordBoardCardComponent,
  ToolbarFilterSelectComponent,
  InitialsPipe,
];

@NgModule({
  declarations: COMPONENTS,
  imports: [CommonModule, FormsModule, DropdownModule],
  exports: COMPONENTS,
})
export class ListKitModule {}
